<template>

  <ChartNormal 
  size="12" 
  offset="0" 
  title="Beyond Economical Repair" 
  chart="column" 
  chartType="BER" 
  :isCity="false" 
  :withDate="true" 
  :withFinancial="false" />
  
</template>

<script>
import ChartNormal from "../../components/chart/chartNormal";

export default {
  name: "Beyond Economical Repair",
  components: {
    ChartNormal,
  }
};
</script>

